import { createAction } from "@reduxjs/toolkit";

export const getCount = createAction("getCount");